import {EScene} from '@/types/scene.types'
import clsx from 'clsx'
import {useAtomValue} from 'jotai'
import {gameModeState, sceneState} from '../Store/atoms'
import {ParticipantsCount} from './ParticipantsCount/ParticipantsCount'
import {Stopwatch} from './Stopwatch/Stopwatch'

export const Hud = () => {
  const gameMode = useAtomValue(gameModeState)
  const scene = useAtomValue(sceneState)

  if (scene === EScene.PRE_LOBBY) {
    return null
  }

  return (
    <div
      id="hud"
      className={clsx(
        'pointer-events-none',
        'fixed inset-0 z-50 m-[24px] select-none overflow-hidden',
      )}
    >
      {/* PLayers count */}
      {gameMode !== 'single_player' && scene === EScene.LOBBY && <ParticipantsCount />}

      {/* Stop watch */}
      {scene === EScene.STARTED && <Stopwatch />}
    </div>
  )
}
